// store/index.js
import { createStore } from "vuex";
import { ADMIN_TYPE } from '@/config/adminConfig'

export default createStore({
  state: {
    // 관리자 타입 (qro / myshop)
    admin_type: ADMIN_TYPE.QRO,

    // MYSHOP 마스터 관리 IP 제한
    isAllowedMasterIp: false,    // 서버에서 확인된 허용 IP 여부

    // MYSHOP 관리자 관련 상태
    myshop_info: null,           // MYSHOP 샵 정보
    myshop_skin: null,           // MYSHOP 스킨 설정
    myshop_shopid: null,         // MYSHOP Shop ID

    //
    item_image_url:'https://mimi-image.qro.do/',
    selected_cid:null,
    selected_vendor:null,


    selected_uid:null,
    login_token:'',
    hide_menu:false,
    admin: null,
    login: null,
    mobile: null,
    login_data : null,
    mod_sorting : false,
    uid:null,
    flutterWindows:false,
    wheelDelta:null,
    scrolling:false,
    table_order_noti:null,
    menu_title:null,
    clr_info:null,
    is_subuser: false,
    sub_permissions: null,
    agency:null,
    filter_list:null,
    agency_sub_accounts: [],     // 에이전시 서브 계정 목록
  },
  getters: {
    // 관리자 타입 관련
    admin_type(state) {
      return state.admin_type
    },
    isMyshopAdmin(state) {
      return state.admin_type === ADMIN_TYPE.MYSHOP
    },
    isQroAdmin(state) {
      return state.admin_type === ADMIN_TYPE.QRO
    },
    // MYSHOP 마스터 관리 IP 허용 여부
    isAllowedMasterIp(state) {
      return state.isAllowedMasterIp
    },
    myshop_info(state) {
      return state.myshop_info
    },
    myshop_skin(state) {
      return state.myshop_skin
    },
    myshop_shopid(state) {
      return state.myshop_shopid
    },

    selected_cid(state) {
      return state.selected_cid
    },
    selected_vendor(state) {
      return state.selected_vendor
    },
    selected_uid(state) {
      return state.selected_uid
    },
    item_image_url(state) {
      return state.item_image_url
    },

    filter_list(state) {
      return state.filter_list
    },
    agency_sub_accounts(state) {
      return state.agency_sub_accounts
    },
    is_subuser(state) {
      return state.is_subuser
    },
    sub_permissions(state) {
      return state.sub_permissions
    },

    agency(state) {
      return state.agency
    },
    login_token(state) {
      return state.login_token
    },
    hide_menu(state) {
      return state.hide_menu
    },
    admin(state) {
      return state.admin
    },
    menu_title(state) {
      return state.menu_title
    },
    table_order_noti(state) {
      return state.table_order_noti
    },
    scrolling(state) {
      return state.scrolling
    },
    wheelDelta(state) {
      return state.wheelDelta
    },
    uid(state) {
      return state.uid
    },
    mobile(state) {
      return state.mobile
    },
    flutterWindows(state) {
      return state.flutterWindows
    },
    login(state) {
      return state.login
    },
    login_data(state) {
      return state.login_data
    },
    mod_sorting(state) {
      return state.mod_sorting
    },
    clr_info(state) {
      return state.clr_info
    },
  },
  mutations: {
    // 관리자 타입 관련
    admin_type(state, value) {
      state.admin_type = value;
    },
    // MYSHOP 마스터 관리 IP 허용 여부
    isAllowedMasterIp(state, value) {
      state.isAllowedMasterIp = value;
    },
    myshop_info(state, value) {
      state.myshop_info = value;
    },
    myshop_skin(state, value) {
      state.myshop_skin = value;
    },
    myshop_shopid(state, value) {
      state.myshop_shopid = value;
    },

    selected_cid(state, value) {
      state.selected_cid = value;
    },
    selected_vendor(state, value) {
      state.selected_vendor = value;
    },
    selected_uid(state, value) {
      state.selected_uid = value;
    },
    item_image_url(state, value) {
      state.item_image_url = value;
    },

    filter_list(state, value) {
      state.filter_list = value;
    },
    agency_sub_accounts(state, value) {
      state.agency_sub_accounts = value;
    },
    is_subuser(state, value) {
      state.is_subuser = value;
    },
    sub_permissions(state, value) {
      state.sub_permissions = value;
    },

    login_token(state, value) {
      state.login_token = value;
    },
    hide_menu(state, value) {
      state.hide_menu = value;
    },
    menu_title(state, value) {
      state.menu_title = value;
    },
    table_order_noti(state, value) {
      state.table_order_noti = value;
    },
    scrolling(state, value) {
      state.scrolling = value;
    },
    wheelDelta(state, value) {
      state.wheelDelta = value;
    },
    flutterWindows(state, value) {
      state.flutterWindows = value;
    },
    uid(state, value) {
      state.uid = value;
    },
    admin(state, value) {
      state.admin = value;
    },
    agency(state, value) {
      state.agency = value;
    },
    mobile(state, value) {
      state.mobile = value;
    },
    login(state, value) {
      state.login = value;
    },
    login_data(state, value) {
      state.login_data = value;
    },
    clr_info(state, value) {
      state.clr_info = value;
    },
    mod_sorting(state, value) {
      state.mod_sorting = value;
    },
  }
});